import { createContext, useContext } from "react"

export const SolutionContext = createContext({
  selectedTab: "propertyManagement",
  toggleSelectedTab: () => {},
})

export const useSolution = () => useContext(SolutionContext)
export const SolutionProvider = SolutionContext.Provider
